import React, { FC } from "react";
import "./BlogPage.style.css";

export const BlogPage: FC = () => {
  return (
    <div className="blogpage-content">
      <h1>First Blog Post</h1>
      <p>Some blog content</p>
    </div>
  );
};

export default BlogPage;
